import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

import mail from '@sendgrid/mail'
import cors from 'cors'

import { BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(mail);
Vue.use(cors);
Vue.use(BootstrapVueIcons);

import ('../styles/styles-va.css');

Vue.config.productionTip = false

new Vue({
  router,
  store,
  mail,
  cors,
  render: h => h(App)
}).$mount('#app')
